export const RENT_INCREASE_TYPES = {
    Amount: 1,
    MarketRent: 2,
    Percentage: 3,
};
export const ROUND_RULES = {
    None: 0,
    RoundUp: 1,
    RoundDown: 2,
};
